import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, watch } from "vue";
import WorkScheduleListAddBtn from "./WorkScheduleListAddBtn.vue";
import { List } from "../UserMasterWorkSchedule";
import { useConfirm } from "@/plugins/confirm/confirm";

type Props = {
  value: List[];
  userId?: number;
};
type Emits = {
  (e: "input", value: List[]): void;
  (e: "click", value?: number): void;
  (e: "delete", value: number): void;
};

export default /*#__PURE__*/_defineComponent({
  __name: 'WorkScheduleList',
  props: {
    value: null,
    userId: null
  },
  emits: ["input", "click", "delete"],
  setup(__props: any, { emit: emits }: { emit: ({
  (e: "input", value: List[]): void;
  (e: "click", value?: number): void;
  (e: "delete", value: number): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  value: List[];
  userId?: number;
};

const { $deleteConfirm } = useConfirm();




const modelValue = computed({
  get: () => props.value,
  set: value => emits("input", value)
});

const index = ref<number>();

const onSelect = (item: List) => {
  modelValue.value.push(item);
};

const onDelete = async (item: List) => {
  const message = "この所属の現状届をすべて削除します。\nよろしいですか？";
  const confirm = await $deleteConfirm(message);
  if (confirm) emits("delete", item.value);
};
watch(index, i => {
  const val = i != null ? modelValue.value[i] : undefined;
  emits("click", val?.value);
});

return { __sfc: true,$deleteConfirm, props, emits, modelValue, index, onSelect, onDelete, WorkScheduleListAddBtn }
}

})